<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newRtnLim">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newRtnLim">Create Retention Limit</v-toolbar-title>
          <v-toolbar-title v-else-if="isQueryRtnLim == 'true'">Query Retention Limit</v-toolbar-title>
          <v-toolbar-title v-else>Edit Retention Limit</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newRtnLim">
                <v-autocomplete
                  @input="getAccumType"
                  :items="accumtypes"
                  v-model="rtnLimForm.accmType"
                  v-validate="'required'"
                  :label="labels.accmType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="accmType"
                  :error-messages="errors.collect('accmType')"
                  :data-vv-as="labels.accmType"
                ></v-autocomplete>
                <!-- <v-text-field v-model="rtnLimForm.accmType" :label="labels.accmType" :error-messages="errors.collect('accmType')" data-vv-name="accmType" :data-vv-as="labels.accmType" v-validate="'required|param|max:2'">
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('accmType')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field> -->
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.accmType }}</v-subheader>
                <div class="queryValue">{{ rtnLimForm.accmType }}</div>
              </v-flex>
              <v-flex xs6></v-flex>
              <v-flex xs6 v-if="newRtnLim">
                <v-text-field
                  :disabled="fac1Disable === true"
                  :label="labels.fact1Val"
                  data-vv-name="fact1Val"
                  v-model="rtnLimForm.fact1ValWithDesc"
                  :data-vv-as="labels.fact1Val"
                  :error-messages="errors.collect('fact1Val')"
                  v-validate="'required'"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon v-if="!fac1Disable" color="info" @click="getHelpList('fac1Val')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs4 v-else>
                <v-subheader class="queryLabel">{{ labels.fact1Val }}</v-subheader>
                <div class="queryValue">{{ rtnLimForm.fact1Val }} - {{ rtnLimForm.fact1ValDesc }}</div>
              </v-flex>
              <v-flex xs6 v-if="newRtnLim">
                <v-text-field
                  :disabled="fac2Disable === true"
                  :label="labels.fact2Val"
                  data-vv-name="fact2Val"
                  v-model="rtnLimForm.fact2ValWithDesc"
                  :data-vv-as="labels.fact2Val"
                  :error-messages="errors.collect('fact2Val')"
                  v-validate="'required'"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon v-if="!fac2Disable" color="info" @click="getHelpList('fac2Val')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs4 v-else>
                <v-subheader class="queryLabel">{{ labels.fact2Val }}</v-subheader>
                <div class="queryValue">{{ rtnLimForm.fact2Val }} - {{ rtnLimForm.fact2ValDesc }}</div>
              </v-flex>
              <v-flex xs6 v-if="newRtnLim">
                <v-text-field
                  :disabled="fac3Disable === true"
                  :label="labels.fact3Val"
                  data-vv-name="fact3Val"
                  v-model="rtnLimForm.fact3ValWithDesc"
                  :data-vv-as="labels.fact3Val"
                  :error-messages="errors.collect('fact3Val')"
                  v-validate="'required'"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon v-if="!fac3Disable" color="info" @click="getHelpList('fac3Val')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs4 v-else>
                <v-subheader class="queryLabel">{{ labels.fact3Val }}</v-subheader>
                <div class="queryValue">{{ rtnLimForm.fact3Val }} - {{ rtnLimForm.fact3ValDesc }}</div>
              </v-flex>
              <v-flex xl4 lg4 xs6>
                <v-select
                  :disabled="newRtnLim === false"
                  v-model="rtnLimForm.limType"
                  :label="labels.limType"
                  :items="limTypeList"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('limType')"
                  data-vv-name="limType"
                  :data-vv-as="labels.limType"
                  v-validate="'required|max:2'"
                ></v-select>
              </v-flex>
              <v-flex lg4 xs6>
                <cal-picker
                  :disabled="newRtnLim === false"
                  v-model="rtnLimForm.effDate"
                  v-validate="'required'"
                  :label="labels.effDate"
                  :data-vv-as="labels.effDate"
                  data-vv-name="effDate"
                  :error-messages="errors.collect('effDate')"
                ></cal-picker>
              </v-flex>
              <v-flex lg4 xs4>
                <v-text-field
                  :readonly="isQueryRtnLim == 'true'"
                  v-model="rtnLimForm.ownRtn"
                  :label="labels.ownRtn"
                  data-vv-name="ownRtn"
                  :data-vv-as="labels.ownRtn"
                  :error-messages="errors.collect('ownRtn')"
                  v-validate="'entry|numeric'"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :readonly="isQueryRtnLim == 'true'"
                  v-model="rtnLimForm.remark"
                  :label="labels.remark"
                  v-validate="'max:100'"
                  :error-messages="errors.collect('remark')"
                  data-vv-name="remark"
                  :data-vv-as="labels.remark"
                  auto-grow
                  :counter="100"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ createdDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 v-if="!newRtnLim">
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ modifiedName }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newRtnLim">
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ modifiedDate }}</div>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mr-2" color="error" @click="doCancel" :loading="loading">
                  <span>Cancel</span>
                  <v-icon right dark>mdi-cancel</v-icon>
                </v-btn>
                <v-btn v-if="isQueryRtnLim != 'true'" color="primary" dark class="mr-2" @click="doSave" :loading="loading">
                  {{ newRtnLim ? 'Save Retention Limit' : 'Save Retention Limit' }}
                  <v-icon right>{{ newRtnLim ? 'mdi-content-save' : 'mdi-content-save' }} </v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-dialog v-model="helplist" width="900px" persistent>
        <accmType-help-list v-if="accmTypeHelpList" @close="doClose"></accmType-help-list>
        <fac1Val-help-list v-if="fac1ValHelpList" @close="doClose" :data="this.rtnLimForm" @fac1Val="doAssignFac1Val($event)"></fac1Val-help-list>
        <fac2Val-help-list v-if="fac2ValHelpList" @close="doClose" :data="this.rtnLimForm" @fac2Val="doAssignFac2Val($event)"></fac2Val-help-list>
        <fac3Val-help-list v-if="fac3ValHelpList" @close="doClose" :data="this.rtnLimForm" @fac3Val="doAssignFac3Val($event)"></fac3Val-help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { commonMixins } from '@/mixins/common/commonMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AccmTypeHelpList from './helplist/AccmTypeHelplist'
import Fac1ValHelpList from './helplist/Fac1ValHelplist'
import Fac2ValHelpList from './helplist/Fac2ValHelplist'
import Fac3ValHelpList from './helplist/Fac3ValHelplist'
import { limType } from '@/const/params'

export default {
  data() {
    return {
      labels: {
        accmType: 'Accumulation Type',
        fact1Val: 'Factor 1 Value',
        fact2Val: 'Factor 2 Value',
        fact3Val: 'Factor 3 Value',
        limType: 'Limit Type',
        effDate: 'Effective Date',
        ownRtn: 'Own Retention',
        remark: 'Remarks',
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      rtnLimForm: {
        accmType: undefined,
        rtnLimKey1: undefined,
        rtnLimKey2: undefined,
        rtnLimKey3: undefined,
        fact1Val: undefined,
        fact1ValDesc: undefined,
        fact1ValWithDesc: undefined,
        fact2Val: undefined,
        fact2ValDesc: undefined,
        fact2ValWithDesc: undefined,
        fact3Val: undefined,
        fact3ValDesc: undefined,
        fact3ValWithDesc: undefined,
        limType: 'T',
        effDate: new Date(),
        ownRtn: 0,
        remark: undefined
      },
      accumtypes: [],
      newRtnLim: false,
      helplist: false,
      accmTypeHelpList: false,
      fac1ValHelpList: false,
      fac2ValHelpList: false,
      fac3ValHelpList: false,
      fac1Disable: true,
      fac2Disable: true,
      fac3Disable: true,
      createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: formatDisplayDate(new Date()),
      modifiedName: '',
      modifiedDate: ''
    }
  },
  computed: {
    rtnLimList() {
      return this.$store.state.rtnLimParam.menu
    },
    limTypeList() {
      let result = []
      Object.keys(limType).forEach(function (key) {
        const status = limType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    isQueryRtnLim() {
      return this.$route.params.isQueryRtnLim
    }
  },
  methods: {
    getHelpList(fieldname) {
      this.helplist = true
      if (fieldname === 'accmType') {
        this.accmTypeHelpList = true
      } else if (fieldname === 'fac1Val') {
        this.fac1ValHelpList = true
        // this.doShowFac1()
      } else if (fieldname === 'fac2Val') {
        this.fac2ValHelpList = true
        // this.doShowFac1()
      } else if (fieldname === 'fac3Val') {
        this.fac3ValHelpList = true
        // this.doShowFac1()
      }
    },
    async doFetch() {
      const apiUrl = this.rtnLimList.getRtnLim
      const requestParams = {
        accmType: this.rtnLim.accmType,
        fact1Val: this.rtnLim.fact1Val,
        fact2Val: this.rtnLim.fact2Val,
        fact3Val: this.rtnLim.fact3Val
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.rtnLimForm.fact1ValDesc = data.rtnLim.fact1ValDesc
            this.rtnLimForm.fact2ValDesc = data.rtnLim.fact2ValDesc
            this.rtnLimForm.fact3ValDesc = data.rtnLim.fact3ValDesc
            this.rtnLimForm.fact1ValWithDesc = this.rtnLim.fact1Val + ' - ' + data.rtnLim.fact1ValDesc
            this.rtnLimForm.fact2ValWithDesc = this.rtnLim.fact2Val + ' - ' + data.rtnLim.fact2ValDesc
            this.rtnLimForm.fact3ValWithDesc = this.rtnLim.fact3Val + ' - ' + data.rtnLim.fact3ValDesc
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async getAccumType() {
      const apiUrl = this.rtnLimList.getAccmType
      const requestParams = {
        accmType: this.rtnLimForm.accmType
      }
      if (apiUrl) {
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            if (this.newRtnLim) {
              if (data.accumType.rtnLimKey1 === '99') {
                this.fac1Disable = true
                this.rtnLimForm.rtnLimKey1 = data.accumType.rtnLimKey1
              } else {
                this.fac1Disable = false
                this.rtnLimForm.rtnLimKey1 = data.accumType.rtnLimKey1
              }
              if (data.accumType.rtnLimKey2 === '99') {
                this.fac2Disable = true
                this.rtnLimForm.rtnLimKey2 = data.accumType.rtnLimKey2
              } else {
                this.fac2Disable = false
                this.rtnLimForm.rtnLimKey2 = data.accumType.rtnLimKey2
              }
              if (data.accumType.rtnLimKey3 === '99') {
                this.fac3Disable = true
                this.rtnLimForm.rtnLimKey3 = data.accumType.rtnLimKey3
              } else {
                this.fac3Disable = false
                this.rtnLimForm.rtnLimKey3 = data.accumType.rtnLimKey3
              }
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      }
    },
    // async doShowAccm() {
    //   const apiUrl = this.rtnLimList.getAccmType
    //   if (apiUrl) {
    //     this.loading = true
    //     try {
    //       const result = await this.$http.get(apiUrl)
    //       this.items = []
    //     } catch (err) {

    //     }
    //   }
    // },
    // async doShowFac1() {
    //   console.log(this.rtnLimForm.rtnLimKey1)
    //   const apiUrl = this.rtnLimList.getFacValList
    //   const requestParams = {
    //     facVal: this.rtnLimForm.rtnLimKey1
    //   }
    //   if (apiUrl) {
    //     try {
    //       const result = await this.$http.get(expandURI(apiUrl, requestParams))
    //       this.items = []
    //       const { data } = result.data
    //       if (data) {
    //         data.map(facVal => {
    //           const convertList = {
    //             inter: facVal.inter,
    //             name: facVal.name
    //           }
    //           this.items.push(convertList)
    //         })
    //       }
    //       console.log(this.items)
    //       this.loading = false
    //     } catch (err) {
    //       this.loading = false
    //       const { data } = err.response.data
    //       if (data) {
    //         this.message(data)
    //       }
    //     }
    //   }
    // },
    doAssignFac1Val(facVal) {
      // this.$validator.errors.remove('region1')
      this.rtnLimForm.fact1Val = facVal.facVal
      this.rtnLimForm.fact1ValDesc = facVal.facValDesc
      this.rtnLimForm.fact1ValWithDesc = this.rtnLimForm.fact1Val + ' - ' + this.rtnLimForm.fact1ValDesc
    },
    doAssignFac2Val(facVal) {
      // this.$validator.errors.remove('region1')
      this.rtnLimForm.fact2Val = facVal.facVal
      this.rtnLimForm.fact2ValDesc = facVal.facValDesc
      this.rtnLimForm.fact2ValWithDesc = this.rtnLimForm.fact2Val + ' - ' + this.rtnLimForm.fact2ValDesc
    },
    doAssignFac3Val(facVal) {
      // this.$validator.errors.remove('region1')
      this.rtnLimForm.fact3Val = facVal.facVal
      this.rtnLimForm.fact3ValDesc = facVal.facValDesc
      this.rtnLimForm.fact3ValWithDesc = this.rtnLimForm.fact3Val + ' - ' + this.rtnLimForm.fact3ValDesc
    },
    doShowFac2() {},
    doShowFac3() {},
    doSave() {
      // this.resetValidator()
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newRtnLim) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        }
      })
    },
    doClose() {
      this.helplist = false
      setTimeout(() => {
        this.accmTypeHelpList = false
        this.fac1ValHelpList = false
        this.fac2ValHelpList = false
        this.fac3ValHelpList = false
      }, 500)
    },
    async doCreate() {
      const apiUrl = this.rtnLimList.createRtnLim
      if (apiUrl) {
        this.loading = true
        this.rtnLimForm.effDate = removeTime(this.rtnLimForm.effDate)
        try {
          const result = await this.$http.post(apiUrl, this.rtnLimForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiUrl = this.rtnLimList.updateRtnLim
      if (apiUrl) {
        this.loading = true
        try {
          const result = await this.$http.put(apiUrl, this.rtnLimForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
      this.loading = false
    },
    doCancel() {
      this.$router.push({ name: 'rtnLimList' })
    }
  },
  created() {
    if (this.rtnLim === 'new') {
      this.newRtnLim = true
      this.getCommonDataListDropDown('accumtypes')
    } else {
      if (this.rtnLim.fact1Val !== undefined) {
        this.fac1Disable = false
      }
      if (this.rtnLim.fact2Val !== undefined) {
        this.fac2Disable = false
      }
      if (this.rtnLim.fact3Val !== undefined) {
        this.fac3Disable = false
      }
      this.rtnLimForm.accmType = this.rtnLim.accmType
      this.rtnLimForm.fact1Val = this.rtnLim.fact1Val
      this.rtnLimForm.fact2Val = this.rtnLim.fact2Val
      this.rtnLimForm.fact3Val = this.rtnLim.fact3Val
      this.rtnLimForm.limType = this.rtnLim.limType
      this.rtnLimForm.effDate = this.rtnLim.effDate
      this.rtnLimForm.ownRtn = this.rtnLim.ownRtn
      this.rtnLimForm.remark = this.rtnLim.remark
      this.modifiedName = this.rtnLim.modifiedName
      this.modifiedDate = this.rtnLim.modifiedDate
      this.createdName = this.rtnLim.createdName
      this.createdDate = this.rtnLim.createdDate
      this.doFetch()
      this.getAccumType()
    }
  },
  mixins: [MessageMixin, commonMixins, commonAjaxMixin, TableConst.default],
  components: {
    AccmTypeHelpList,
    Fac1ValHelpList,
    Fac2ValHelpList,
    Fac3ValHelpList
  },
  props: ['rtnLim']
}
</script>
